import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoCadastro } from '../models/projeto-cadastro.model';

@Injectable({
  providedIn: 'root',
})
export class PesquisaGeralService extends BaseService<any> {
  private infoProjectSource = new BehaviorSubject<ProjetoCadastro>({});
  info = this.infoProjectSource.asObservable();

  constructor(public http: HttpClient) {
    super(http);
  }

  setInfoProject(info: any) {
    this.infoProjectSource.next(info);
  }

  public getPathModule(): string {
    return '/projetos/pesquisa-geral';
  }

  public listFilters(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + "/list-filters", { headers: this.headers });
  }

  public getListSearchProjetos(obj: any = null): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + '/search-projetos', obj, { headers: this.headers });
  }

  public responsavelAdjProjeto(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + "/responsavel-adjunto-projeto/" + id, { headers: this.headers });
  }

  public infoProjeto(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + "/info-projeto/" + id, { headers: this.headers });
  }
}
